import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    const load_url = this.urlValue;
    $('#ncworkno-select').selectize({
      plugins: ["remove_button"],
      respect_word_boundaries: false,
      valueField: "clerk_code",
      labelField: "chinese_name",
      searchField: ['clerk_code','chinese_name'],
      create: false,
      load: function (query, callback) {
        if (!query.length) return callback();
        $.ajax({
          url: `${load_url}?q=${encodeURIComponent(query)}`,
          type: "GET",
          error: function () {
            callback();
          },
          success: function (res) {
            callback(res.users);
          },
        });
      },
    });
  }
}
